import { DeviceState } from '../../../@types';
const initialState: DeviceState = {
  status: {
    cameraPermission: 'unavailable',
    locationPermission: 'unavailable',
    bluetoothPermission: 'granted',
    devicePaired: true,
    deviceConnected: true,
  },
  lastKnownLocation: null,
  deviceUUID: '',
  platform: null,
  language: null,
  model: '',
  pushToken: '',
  pushDeviceID: '',
  userAgent: '',
  orientation: '',
  totalMemory: null,
  usedMemory: null,
  isKeyboardOpened: false,
};
export default initialState;
